import {
  useIsFeatureActive,
  useIsSoftFeatureToggleActive,
} from '@aboutyou/feature-flags';
import {useContactDetails} from '@aboutyou/legacy-desktop/src/app/helpers/hooks/useContactDetails';
import {useRouter} from '@aboutyou/legacy-desktop/src/app/helpers/navigation';
import {PageTrackingContextProvider} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/PageTrackingContext';
import {useTracking} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/hooks/useTrackingContextAndClientV6';
import {useTrackingPageUrl} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/hooks/useTrackingPageUrl';
import TrackContentPageView from '@aboutyou/legacy-desktop/src/app/helpers/tracking/trackerComponents/TrackContentPageView';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/HelpCenter/redialHelpCenterContactPage';
import {useHelpCenterCanonicalUrl} from '@aboutyou/legacy-desktop/src/app/pages/HelpCenter/seo';
import useHelpCenterTranslations from '@aboutyou/legacy-desktop/src/app/pages/HelpCenter/useHelpCenterTranslations';
import {useService} from '@aboutyou/legacy-desktop/src/app/services/utils/context';
import {
  useHelpCenterContactPageStore,
  useUrlManagerStore,
} from '@aboutyou/legacy-desktop/src/app/store/context';
import {useLocale} from '@aboutyou/legacy-desktop/src/app/store/features/locale/useLocale';
import LegacyPage from '@aboutyou/legacy-shared/src/pages/HelpCenter/HelpCenterContactPage';
import {TrackingPageTypeWithoutId} from '@aboutyou/legacy-tracking-sdk';
import {CloudflareTurnstile} from '@aboutyou/logic-components';
import {useShowToast} from '@aboutyou/ui-components';
import React from 'react';
import redial from 'redial';
import {withLegacyProviders} from '../../LegacyComponentWrapper';

const ConnectedHelpCenterContactPage: React.FC<
  React.PropsWithChildren
> = () => {
  const showToast = useShowToast();
  const translations = useHelpCenterTranslations({});

  const {TrackingClient} = useTracking();
  const {navigateClient} = useRouter();

  const sections = useHelpCenterContactPageStore(store => store.sections);
  const canonical = useHelpCenterCanonicalUrl();
  const {path, search} = useTrackingPageUrl();
  const service = useService();
  const {helpCenter} = useService();

  const {mailTo} = useContactDetails();
  const isProduction = useUrlManagerStore(store => store.isProduction);
  const {locale} = useLocale();

  const isShowOldHelpCenterEnabled =
    useIsSoftFeatureToggleActive('show_old_help_center') === true;

  const isCoinsActive = useIsFeatureActive('ff_coins_rollout').isActive;

  return (
    <PageTrackingContextProvider
      path={path}
      search={search}
      type={TrackingPageTypeWithoutId.HelpCenterContact}
    >
      <TrackContentPageView
        pageTitle={translations.contactPage.seo_page_title}
      />
      <LegacyPage
        locale={locale}
        localizedServiceEmailAddress={mailTo!}
        isProduction={isProduction}
        endpoints={helpCenter}
        sendContactForm={service.helpCenter.sendContactForm}
        canonicalUrl={canonical}
        trackingClient={TrackingClient}
        translations={translations}
        navigateClient={navigateClient}
        sections={sections}
        isShowOldHelpCenterEnabled={isShowOldHelpCenterEnabled}
        isCoinsActive={isCoinsActive}
        CloudflareTurnstile={CloudflareTurnstile}
        showToast={showToast}
      />
    </PageTrackingContextProvider>
  );
};

const PageWithRedial = redial.provideHooks(redialHandle)(
  ConnectedHelpCenterContactPage,
);

export const ContactForm = withLegacyProviders(PageWithRedial);
